/* Supps247 polish pack, 11 Oct 2026. Rollback folder 83.
   1. Scroll progress driver: any element with [data-s247-scroll] gets a CSS variable --p (0 when its top reaches the
      bottom of the screen, 1 when its bottom leaves the top). The CSS in s247-polish.css turns --p into motion.
      The Price Match / Taste It split section is tagged here automatically.
   2. Collection menu filter box.
   3. Footer extras: trust strip, brand intro and column headings (added here so the large footer section file
      stays unchanged).
   Reduced motion: --p is fixed at 0.5 (everything sits in its resting place) and nothing moves. */
(function () {
  'use strict';
  try {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function tagSplit() {
      var list = document.querySelectorAll('[id^="SplitGrid-"]');
      for (var i = 0; i < list.length; i++) {
        var s = list[i];
        if (s.hasAttribute('data-s247-scroll')) continue;
        s.setAttribute('data-s247-scroll', '');
        s.classList.add('s247-split');
        var cols = s.querySelectorAll('.tw-flex-col.tw-items-center.tw-text-center');
        if (cols[0]) cols[0].classList.add('s247-split-l');
        if (cols[1]) cols[1].classList.add('s247-split-r');
        var lines = s.querySelectorAll('.split-line');
        for (var j = 0; j < lines.length; j++) lines[j].classList.add('s247-split-line');
      }
    }

    function init() {
      tagSplit();
      var els = Array.prototype.slice.call(document.querySelectorAll('[data-s247-scroll]'));
      if (!els.length) return;
      if (reduce) {
        els.forEach(function (e) { e.style.setProperty('--p', '0.5'); e.classList.add('s247-still'); });
        return;
      }
      var ticking = false;
      /* 16 Oct 2026 (rollback folder 105): all positions are read first, then all values written, so the browser
         lays the page out once per frame instead of once per element. Unchanged values are not rewritten. */
      function update() {
        ticking = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var vals = new Array(els.length);
        for (var i = 0; i < els.length; i++) {
          var r = els[i].getBoundingClientRect();
          if (r.bottom < -300 || r.top > vh + 300) { vals[i] = null; continue; }
          var p = (vh - r.top) / (vh + r.height);
          if (p < 0) p = 0; else if (p > 1) p = 1;
          vals[i] = p.toFixed(3);
        }
        for (var k = 0; k < els.length; k++) {
          if (vals[k] === null || els[k].__s247p === vals[k]) continue;
          els[k].__s247p = vals[k];
          els[k].style.setProperty('--p', vals[k]);
        }
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
      els.forEach(function (e) { e.classList.add('s247-live'); });
    }

    function collectionFilter() {
      var boxes = document.querySelectorAll('[data-s247-colfilter]');
      Array.prototype.forEach.call(boxes, function (input) {
        var root = input.closest('.s247-cm');
        if (!root) return;
        var items = root.querySelectorAll('.s247-cm__item');
        var groups = root.querySelectorAll('.s247-cm__group');
        var empty = root.querySelector('.s247-cm__empty');
        input.addEventListener('input', function () {
          var q = input.value.trim().toLowerCase();
          var shown = 0;
          Array.prototype.forEach.call(items, function (a) {
            var hit = !q || a.textContent.toLowerCase().indexOf(q) !== -1;
            a.style.display = hit ? '' : 'none';
            if (hit) shown++;
          });
          Array.prototype.forEach.call(groups, function (g) {
            var any = g.querySelector('.s247-cm__item:not([style*="none"])');
            g.style.display = any ? '' : 'none';
          });
          if (empty) empty.style.display = shown ? 'none' : '';
        });
      });
    }


    function footerExtras() {
      var f = document.querySelector('.mlyn-footer');
      if (!f || f.querySelector('.s247-ft-trust')) return;
      var wrap = f.querySelector('.mlyn-footer-top > div.tw-z-10');
      if (!wrap) return;
      var ic = function (d) { return '<span class="s247-ft-ic" aria-hidden="true"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' + d + '</svg></span>'; };
      var items = [
        [ic('<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/>'), 'Free shipping over $100', 'Australia-wide, $12.98 under $100', '/pages/shipping-information'],
        [ic('<path d="M4 9l1.5-5h13L20 9M4 9v11h16V9M4 9h16M9 20v-6h6v6"/>'), 'Click &amp; collect in 1 hour', 'Pick up from your local store', '/pages/pick-up-in-1-hour'],
        [ic('<path d="M12 3l7 3v5c0 4.4-3 8.2-7 10-4-1.8-7-5.6-7-10V6z"/><path d="M9 12l2 2 4-4"/>'), 'Price match guarantee', 'Members, conditions apply', '/pages/price-match-guarantee'],
        [ic('<rect x="3" y="5.5" width="18" height="13" rx="2"/><path d="M3 10h18M7 15h3"/>'), 'Afterpay &amp; Klarna', 'Pay in instalments', '']
      ];
      var ul = document.createElement('ul');
      ul.className = 's247-ft-trust';
      ul.innerHTML = items.map(function (it) {
        var inner = it[0] + '<div><b>' + it[1] + '</b><span>' + it[2] + '</span></div>';
        return '<li>' + (it[3] ? '<a href="' + it[3] + '">' + inner + '</a>' : inner) + '</li>';
      }).join('');
      wrap.insertBefore(ul, wrap.firstChild);

      var left = ul.nextElementSibling && ul.nextElementSibling.firstElementChild;
      var logo = document.querySelector('img[src*="logo_supps247"]');
      if (left) {
        var brand = document.createElement('div');
        brand.className = 's247-ft-brand';
        brand.innerHTML = (logo ? '<a href="/" aria-label="Supps247 home"><img src="' + logo.getAttribute('src') + '" alt="Supps247" width="180" height="56" loading="lazy"></a>' : '') +
          '<p>Melbourne supplement stores since 2016. 18 stores and Australia-wide delivery, with staff who help you compare labels and taste before you buy.</p>';
        left.insertBefore(brand, left.firstChild);
      }

      var titles = ['Help &amp; info', 'Shop', 'Our stores'];
      var n = 0;
      Array.prototype.forEach.call(f.querySelectorAll('.mlyn-footer-menu-block'), function (b) {
        if (!b.querySelector('ul.mlyn-footer-menu-list')) return;
        n++;
        b.classList.add('s247-ft-col', 's247-ft-col--' + n);
        if (!b.querySelector('h3') && titles[n - 1]) {
          var h = document.createElement('h3');
          h.className = 's247-ft-h';
          h.innerHTML = titles[n - 1];
          b.insertBefore(h, b.firstChild);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); collectionFilter(); footerExtras(); });
    } else { init(); collectionFilter(); footerExtras(); }
  } catch (err) { /* never break the page */ }
})();
